import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CountryService = {
  get: async () => {
    const response = await apiService.get("/client-countries");
    // console.log("responseeee",response)
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get("/countries");
    // console.log("responseeee",response)
    return response.data;
  },
  getBySuburb: async (id) => {
    const response = await apiService.get(`/suburbs/${id}/client-countries`);
    // console.log("responseeee",response)
    return response.data;
  },
  getById: async (id) => {
    const response = await apiService.get(`/countries/${id}`);
    // console.log("responseeee",response)
    return response.data;
  },
  update: async (id, data) => {
    console.log("🚀 ~ update: ~ data:", data);
    try {
      const response = await apiService.patch(`/countries/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating:", error);
      throw error;
    }
  },
  create: async (data) => {
    try {
      const response = await apiService.post("/countries", data);
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/countries/${id}`);
    return response.data;
  },

  resetPasswordDriver: async (data) => {
    const response = await apiService.post(`/users/admin-reset-password`, data);
    return response.data;
  },
};

export default CountryService;
